import React from "react"
import PropTypes from "prop-types"
import _ from "lodash"
import { connect } from "react-redux"
class OriginalSourceTypeTag extends React.Component {
  static propTypes = {
    sourceTypeTagRepo: PropTypes.object.isRequired,
  }
  state = {
    sourceTypeMap: {},
  }
  handleTagData = () => {
    const { sourceTypeTagRepo = {} } = this.props
    let result = {}
    const allTag = _.flatten(_.values(sourceTypeTagRepo))
    if (_.isEmpty(allTag)) return result
    _.map(allTag, (val, key) => {
      const { firstLevelLabel, secondLevelLabel } = val
      result[firstLevelLabel.leadLabelId] = firstLevelLabel.leadLabel
      if (!_.isEmpty(secondLevelLabel)) {
        _.map(secondLevelLabel, (item) => {
          result[item.leadLabelId] = item.leadLabel
        })
      }
    })
    return result
  }
  componentDidMount() {
    let sourceTypeMap = this.handleTagData()
    this.setState({ sourceTypeMap })
  }
  render() {
    const { sourceTypeTag = "", sourceTypeTagId } = this.props
    const { sourceTypeMap } = this.state
    let TagArr = sourceTypeTag.split("/")
    if (sourceTypeTagId) {
      return <span className="OriginalSourceTypeTag">{sourceTypeMap[sourceTypeTagId] ? sourceTypeMap[sourceTypeTagId] : "-"}</span>
    }
    return (
      <span className="OriginalSourceTypeTag">
        {TagArr[1] ? TagArr[1] : TagArr[0]}
        {/* {sourceTypeMap[sourceTypeTag]?sourceTypeMap[sourceTypeTag]:'-'} */}
      </span>
    )
  }
}
function mapStateToProps(state, ownProp) {
  return {
    sourceTypeTagRepo: state.sourceTypeTagRepo,
  }
}

export default connect(mapStateToProps)(OriginalSourceTypeTag)
